export const downloadPdf = (base64String, fileName) => {
    // Decodificar el string base64
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    
    // Crear un elemento de enlace
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName); // Nombre del archivo
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}